// extracted by mini-css-extract-plugin
module.exports = {"column":"_1vDuZMP24n","content":"_3fFLoTAoBo"};
    if(module.hot) {
      // 1597843271808
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  